import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Get initials from a name
export function getInitials(name: string): string {
  if (!name) return '';
  
  const names = name.split(' ');
  if (names.length === 1) return names[0][0].toUpperCase();
  
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
}

// Format currency value
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

// Format phone number
export function formatPhone(phone: string): string {
  if (!phone) return '';
  
  // Remove non-numeric characters
  const numbers = phone.replace(/\D/g, '');
  
  // Format: (XX) XXXXX-XXXX
  if (numbers.length === 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }
  
  return phone;
}

// Generate WhatsApp URL
export function generateWhatsAppUrl(phone: string, message: string): string {
  if (!phone) return '';
  
  // Remove all non-numeric characters and ensure it starts with country code
  let formattedPhone = phone.replace(/\D/g, '');
  
  // If phone doesn't start with country code, add Brazil's code (55)
  if (!formattedPhone.startsWith('55') && formattedPhone.length >= 10) {
    formattedPhone = '55' + formattedPhone;
  }
  
  // Ensure we have a valid phone number
  if (formattedPhone.length < 12) {
    console.warn('Invalid phone number for WhatsApp:', phone);
    return '';
  }
  
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
}

// Generate URL-friendly slug
export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}